import { ChatRecordProperty, Field, UUID } from '@indigohive/cogfy-types'
import { PreviewChatContent } from '../../../FieldCell/components'
import { MessageSquareIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@tanstack/react-query'
import { useCogfy, useToasts } from '../../../../hooks'
import { GetRecordByIdResult } from '@indigohive/cogfy-types/endpoints/getRecordById'
import { useNavigate } from 'react-router-dom'
import clsx from 'clsx'

export type ChatRecordProperyInputProps = {
  workspace: string
  collectionId: UUID
  field: Field
  record: GetRecordByIdResult
  property?: ChatRecordProperty
}

export function ChatRecordProperyInput (props: ChatRecordProperyInputProps) {
  const { workspace, collectionId, field, record, property } = props

  const { t } = useTranslation()
  const cogfy = useCogfy()
  const toast = useToasts()
  const navigate = useNavigate()
  const lastMessage = property?.chat?.value?.lastMessage
  const chatId = property?.chat?.value?.chatId

  const createChat = useMutation({
    mutationFn: async () => {
      return await cogfy.createChat({
        recordId: record.id,
        fieldId: field.id,
        collectionId
      })
    },
    onError: () => toast.error(t('Error creating chat')),
    onSuccess: data => navigate(`/${workspace}/chats/${data.id}`)
  })

  return (
    <div className="flex w-full">
      {lastMessage?.content && lastMessage.role && (
        <PreviewChatContent
          to={`/${workspace}/chats/${chatId}`}
          date={lastMessage.sendDate}
          lastMessage={lastMessage}
          chatProvider={property?.chat.value?.provider}
        />
      )}

      {!(lastMessage?.content && lastMessage.role) && (
        <div
          className={clsx(
            'cursor-pointer',
            'h-full',
            'w-full',
            'px-2',
            'py-1',
            'flex',
            'items-start',
            'hover:bg-base-200',
            'active:bg-base-300',
            'gap-1',
            'text-gray-600'
          )}
          onClick={() => {
            if (chatId) {
              navigate(`/${workspace}/chats/${chatId}`)
            } else {
              createChat.mutate()
            }
          }}
        >
          <div className="grow line-clamp-2">
            <span className="font-medium text-gray-600 inline-flex gap-1.5 items-center mr-1">
              <MessageSquareIcon size={12} />
              {chatId ? t('View chat') : t('Start chat')}
            </span>
          </div>
        </div>
      )}
    </div>
  )
}
